import { render, staticRenderFns } from "./PasswordInput.vue?vue&type=template&id=23a1037c&scoped=true"
import script from "./PasswordInput.vue?vue&type=script&lang=ts"
export * from "./PasswordInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a1037c",
  null
  
)

export default component.exports